/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $ContractReviewerType = {
  type: 'Enum',
} as const;
